import CableReady from 'cable_ready'
import consumer from "./consumer"


$(document).on('turbolinks:load', function () {
    let lobby_id = $('#chat').attr('data-chat-id')
    if (lobby_id != null)
        consumer.subscriptions.create({channel: "ChatChannel", lobby_id: lobby_id}, {
            connected() {
                // Called when the subscription is ready for use on the server

                console.log("Conectado al chat ...: ", lobby_id)
            },

            disconnected() {
                // Called when the subscription has been terminated by the server
                console.log("Desconectado del chat ...: ", lobby_id)
            },

            received(data) {
                // Called when there's incoming data on the websocket for this channel
                console.log("data: ", data)
                if (data.cableReady) {
                    CableReady.perform(data.operations)
                    var chatWindow = document.getElementById('chat-window');
                    var xH = chatWindow.scrollHeight;
                    chatWindow.scrollTo(0, xH);
                }
                // $('#confirmModal').modal('show')
            }
        });

    else
        consumer.disconnect()
});